import {ApolloClient} from 'apollo-client'
import {ApolloLink} from "apollo-link";
import {createHttpLink} from 'apollo-link-http'
import {onError} from 'apollo-link-error'
import ApolloLinkTimeout from 'apollo-link-timeout'
import {InMemoryCache} from 'apollo-cache-inmemory'
import Vue from 'vue'
import VueApollo from 'vue-apollo'
import router from '../router'

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: process.env.VUE_APP_API_URL,
});

const middlewareLink = new ApolloLink((operation, forward) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
        operation.setContext({
            headers: {
                Authorization: token
            }
        });
    }
    return forward(operation);
});

const errorLink = onError(({ graphQLErrors}) => {
    if (graphQLErrors) {
        if (graphQLErrors.some(({extensions}) => extensions && extensions.code === "UNAUTHENTICATED")) {
            router.push('/auth/logout');
        }
    }
    // if (networkError) console.log(`[Network error]: ${networkError}`);
});

const timeoutLink = new ApolloLinkTimeout(30000);

const link = middlewareLink.concat(errorLink).concat(timeoutLink).concat(httpLink);

// Cache implementation
const cache = new InMemoryCache({
    cacheRedirects: {
        Query: {
            people: (_, args, { getCacheKey }) =>
              args.ids.map(id =>
                getCacheKey({ __typename: 'Person', id: id }))
        }
    }
});

ApolloClient.prototype.queryAll = async function (queryName, queryOptions) {
    let data = null;
    do {
        if (data) {
            queryOptions.variables.after = data.pageInfo.endCursor;
        }
        const response = await this.query(queryOptions);
        if (!data) {
            data = {...response.data[queryName]};
        } else {
            data.pageInfo = response.data[queryName].pageInfo;
            if (data.pageInfo.hasNextPage) {
                data.nodes = [...data.nodes, ...response.data[queryName].nodes];
            }
        }
    } while (data.pageInfo.hasNextPage);
    return data;
};

// Create the apollo client
export const apolloClient = new ApolloClient({
    link,
    cache
});

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    errorHandler (error) {
        if(error.gqlError && error.gqlError.extensions && error.gqlError.extensions.code === "UNAUTHENTICATED"){
            router.push('/auth/logout');
        }
    },
});

export default apolloProvider
